<template>
  <div class="field is-horizontal">
    <div class="field-label">
      <slot name="label">
        <label v-if="label" :for="name" class="label">{{ label }}</label>
      </slot>
    </div>
    <div class="field-body">
      <div :class="{ field: true, 'has-addons': !!$slots.addons }">
        <div :class="{ control: true, 'is-expanded': !!$slots.addons }">
          <slot></slot>
        </div>
        <slot name="addons"></slot>
        <slot name="info"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HorizontalField",
  props: {
    name: String,
    label: String,
  },
};
</script>

<style scoped>
.field-label {
  text-align: left;
  min-width: 5em;
  flex-grow: 0;
  margin-right: 1em;
}

.has-long-label .field-label {
  min-width: 14.2em;
}

.is-required .label:after {
  content: "*";
  color: hsl(348, 100%, 61%);
}
</style>
